module.exports = __webpack_public_path__ + "static/media/auth_service_logo.d8970f9f.png";